import Shop from '../shop/shop'
import Sidebar from '../sidebar/sidebar'
import BaseComponent from '../base-component/base-component'
import { checkEnterKey } from '../../utils/utils'
import { debounce } from '../../utils/debounce'

class SortList extends BaseComponent {
  labels: HTMLElement[]

  constructor() {
    super()

    this.labels = [
      ...this.querySelectorAll('[data-sort-list-label]'),
    ] as HTMLElement[]
  }

  connectedCallback(): void {
    this.labels.forEach(label => {
      label.addEventListener('keydown', this.handleLabelKeyDown)
    })

    this.addEventListener('input', this.handleFormInput)
  }

  disconnectedCallback(): void {
    this.labels.forEach(label => {
      label.removeEventListener('keydown', this.handleLabelKeyDown)
    })

    this.removeEventListener('input', this.handleFormInput)
  }

  handleFormInput = debounce((event: SubmitEvent): void => {
    event.preventDefault()

    const shop = this.closest<Shop>('shop-component')
    const sidebarParent = this.closest<Sidebar>('sidebar-component')
    const input = event.target as HTMLInputElement

    if (sidebarParent) {
      sidebarParent.hide()
    }

    if (shop && input) {
      const sortQuery = this.getSortQuery(input)
      const searchParams = [shop.filterQuery, sortQuery].join('&')

      shop.sortQuery = sortQuery
      shop.updateBySearchParams(searchParams)
    }
  }, 250)

  handleLabelKeyDown = (event: KeyboardEvent): void => {
    const isEnterKey = checkEnterKey(event.key || event.keyCode)

    if (isEnterKey) {
      event.preventDefault()

      const target = event.target as HTMLElement
      const input = target.querySelector(`input`)

      if (input) {
        const inputEvent = new MouseEvent('click', { button: 0, which: 1 })

        input.dispatchEvent(inputEvent)
      }
    }
  }

  getSortQuery(input: HTMLInputElement): string {
    const form = input.closest<HTMLFormElement>('form')
    let sortQuery = ''

    if (form) {
      const formData = new FormData(form)

      sortQuery = new URLSearchParams(formData as any).toString()
    }

    return sortQuery
  }
}

export default SortList
